var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',[(_vm.routeRequirementsGeneral)?_c('v-tab',{attrs:{"to":{
      name: 'PatientOverviewHNProgressGeneral',
      params: {
        patientId: _vm.patientId,
      },
    }}},[_vm._v(" "+_vm._s(_vm.$ucfirst(_vm.$t("general")))+" ")]):_vm._e(),(_vm.routeRequirementsWeeklyGoals)?_c('v-tab',{attrs:{"to":{
      name: 'PatientOverviewHNProgressWeeklyGoals',
      params: {
        patientId: _vm.patientId,
      },
    }}},[_vm._v(" "+_vm._s(_vm.$ucfirst(_vm.$t("nutrition.tabs.weeklyGoals")))+" ")]):_vm._e(),(_vm.routeRequirementsOverTime)?_c('v-tab',{attrs:{"to":{
      name: 'PatientOverviewHNProgressOverTime',
      params: {
        patientId: _vm.patientId,
      },
    }}},[_vm._v(" "+_vm._s(_vm.$ucfirst(_vm.$t("nutrition.tabs.progressOverTime")))+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }